/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2024-05-20",
    versionChannel: "nightly",
    buildDate: "2024-05-20T00:05:17.264Z",
    commitHash: "f301b23f6e9bd35fa016070ca2bb69528b680ca9",
};
